import {
  createAuthorizedGetRequest,
  decode,
  encodePaginatableQuery,
  fetchApi,
  PaginatableQuery,
  setQuery,
} from '@/services/api';
import { checklistsResponseCodec } from '@/services/api/resources/homepage/codec';
import { pipe } from 'fp-ts/lib/function';
import { chain, map } from 'fp-ts/TaskEither';

const homepageChecklistsUrl = '/v2/homepage/checklists';

export const listChecklists = (query: PaginatableQuery) => pipe(
  homepageChecklistsUrl,
  createAuthorizedGetRequest,
  map(setQuery(encodePaginatableQuery(query))),
  chain(fetchApi),
  chain(decode(checklistsResponseCodec)),
);
